export class AppConfig {

    // Configuraciones JWT
	// --------------------------------------------------------------------------------------------

	// validar JWT
	public static VALIDAR_JWT = false;
	public static JWT_ISS = 'Portal_BR';
	public static JWT_ALGORITMO = 'HS256';
	public static JWT_TIPO = 'JWT';

	public static JWT_TIEMPO_EXP_MINUTOS = 30;
	public static JWT_TIEMPO_CREA_PREVIO_MINUTOS = 30;

	// Configuraciones de Seguridad
	public static JWT_ID_CLIENTE_INTERLAN = 'paki_wv';


	//Configuracion para determinar el tiempo de desactivaciòn de un boton despues de hacer click
	public static TIEMPO_DESACTIVACION_BTN = 5000;
	//configuracion para el tiempo de espera que tardara en solicitar la contraseña 
	public static TIEMPO_ESPERA_CONTRASENA_TEMPORAL = 3000;
}